// @flow
import type { CompetitionLayoutType } from 'types/CompetitionLayout';
import type { CompetitionListElementType, CompetitionListCategoryType } from 'types/Competition';
import { TYPE_TERRITORIAL, TYPE_FEDERAL, FAMILLE_TEXT, AGE_TEXT, SEXE_TEXT } from 'constants/competitionsConstants';
import { SORT_COMPETITIONS_BASE, SORT_COMPETITIONS_EXTENSION } from 'constants/sortConstants';

export function getUniqueSortedDivisions(competitions: CompetitionLayoutType[]): CompetitionLayoutType[] {
  return competitions
    .reduce((divisionList, currentDivision) => {
      return divisionList.find(a => a.division === currentDivision.division)
        ? divisionList
        : [...divisionList, currentDivision];
    }, [])
    .sort((a, b) => {
      if (a.division < b.division) return -1;
      if (a.division > b.division) return 1;
      return 0;
    });
}

export function getCompetitionsWithType(
  competitions: CompetitionLayoutType[],
  type: TYPE_TERRITORIAL | TYPE_FEDERAL,
  sortByResults?: boolean,
): CompetitionLayoutType[] {
  return competitions
    .filter(c => c.type === type)
    .sort((a, b) => {
      if (!sortByResults) {
        return 0;
      }

      if (a.nouveaux_resultats < b.nouveaux_resultats) return 1;
      if (a.nouveaux_resultats > b.nouveaux_resultats) return -1;
      return 0;
    });
}

export function getCompetitionsByCategory(
  competitions: Array<CompetitionListElementType>
): Array<CompetitionListCategoryType> {
  return competitions.reduce((accumulator, currentValue) => {
    const competitionCategoryTitle = getCompetitionName(currentValue.age, currentValue.sexe, currentValue.famille);
    if (!competitionCategoryTitle) return accumulator;
    const category = accumulator.find(category => category.title === competitionCategoryTitle);

    let index = 0;

    SORT_COMPETITIONS_BASE.forEach(competition => {
      if (competitionCategoryTitle.toLowerCase().includes(competition.value.toLowerCase())) {
        index = competition.index;
      }
    });

    SORT_COMPETITIONS_EXTENSION.forEach(competition => {
      if (competitionCategoryTitle.toLowerCase().includes(competition.value.toLowerCase())) {
        index += competition.index;
      }
    });

    if (category) {
      return [
        ...accumulator.filter(category => category.title !== competitionCategoryTitle),
        { title: competitionCategoryTitle, index, championships: [...category.championships, currentValue] }
      ];
    } else
      return [
        ...accumulator,
        {
          title: competitionCategoryTitle,
          index,
          championships: [currentValue]
        }
      ];
  }, []).sort((a, b) => (a.index - b.index));
}

export function getCompetitionName(age: string, sexe: string, famille: string) {
  const ageEntry = AGE_TEXT.find(entry => entry.type === age);
  const sexeEntry = SEXE_TEXT.find(entry => entry.type === sexe);
  const familleEntry = FAMILLE_TEXT.find(entry => entry.type === famille);
  return ageEntry || sexeEntry || familleEntry
    ? `${ageEntry ? ageEntry.text : ''}${sexeEntry ? sexeEntry.text : ''} ${familleEntry ? familleEntry.text : ''}`
    : null;
}
